import { WebsiteData } from "./../interface/website";
import { errorHandler } from "./errorHandler";
import { apiRequest } from "./apiRequest";

export const enableAllWebsites = async (
  args: Partial<WebsiteData>
): Promise<string> => {
  try {
    const data = await apiRequest<{ message: string }>(
      "patch",
      `/websites/enable-websites`,
      { data: args }
    );

    return data.message;
  } catch (error) {
    console.error("Error in enableAllWebsites:", error);
    errorHandler(error);
    throw new Error("Failed to update all");
  }
};
